export default "__VITE_ASSET__dd08e0e4__"